// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160416/js/" + chunkId + "." + {"44":"91baa934","225":"3dd5f277","481":"365b646e","486":"e5af4b28","770":"c95b05bd"}[chunkId] + ".0.3079139861843724.chunk.js";
};